import { Layout } from '../components';

import { EtcPanel } from '#/components/ui/tickets/components/panels/EtcPanel';
import { HighwayMaintenanceFeePanel } from '#/components/ui/tickets/components/panels/HighwayMaintenanceFeePanel';
import { CompulsoryInsurancePenaltyPanel } from '#/components/ui/tickets/components/panels/CompulsoryInsurancePenaltyPanel';
import { HighwayMaintenanceFeePenaltyPanel } from '#/components/ui/tickets/components/panels/HighwayMaintenanceFeePenaltyPanel';
import {
  useTabBar,
  Tabbar,
  TABS_CONFIG,
} from '#/components/ui/tickets/components/TicketsTabbar';
import { EtcTicketState } from '../etc/model';
import { HighwayMaintenanceFeeTicketState } from '../highway-maintenance-fee/model';
import { CompulsoryInsurancePenaltyTicketState } from '../compulsory-insurance-penalty/model';
import { HighwayMaintenanceFeePenaltyTicketState } from '../highway-maintenance-fee-penalty/model';
import { endOfMonth, startOfMonth } from 'date-fns';
import { Paper } from '@mantine/core';
import { TICKET_MODE } from '../config';

function HistoryTickets() {
  const { currentTab, navigateTab } = useTabBar();
  const now = new Date();
  const mode = TICKET_MODE.HISTORY;

  return (
    <>
      <Paper shadow="xl" radius="lg" p="md">
        <Layout title="歷史任務">
          <Tabbar
            current={currentTab}
            tabsConfig={TABS_CONFIG.map((p) => ({
              ...p,
            }))}
            onChange={(k) => {
              if (!k) return;
              navigateTab(k);
            }}
            shouldRedirectToDefault
          >
            <EtcPanel
              availStates={[
                EtcTicketState.CHARGE_FAILED,
                EtcTicketState.COMPLETED,
                EtcTicketState.NO_FEE,
                EtcTicketState.QUERY_FAILED,
              ]}
              defaultOptions={{
                fromDate: startOfMonth(now),
                toDate: endOfMonth(now),
              }}
              mode={mode}
            />
            <HighwayMaintenanceFeePanel
              availStates={[
                HighwayMaintenanceFeeTicketState.CHARGE_FAILED,
                HighwayMaintenanceFeeTicketState.COMPLETED,
                HighwayMaintenanceFeeTicketState.NO_FEE,
                HighwayMaintenanceFeeTicketState.QUERY_FAILED,
              ]}
              defaultOptions={{
                fromDate: startOfMonth(now),
                toDate: endOfMonth(now),
              }}
              mode={mode}
            />
            <CompulsoryInsurancePenaltyPanel
              availStates={[
                CompulsoryInsurancePenaltyTicketState.CHARGE_FAILED,
                CompulsoryInsurancePenaltyTicketState.COMPLETED,
                CompulsoryInsurancePenaltyTicketState.NO_FEE,
                CompulsoryInsurancePenaltyTicketState.QUERY_FAILED,
              ]}
              defaultOptions={{
                fromDate: startOfMonth(now),
                toDate: endOfMonth(now),
              }}
              mode={mode}
            />
            <HighwayMaintenanceFeePenaltyPanel
              availStates={[
                HighwayMaintenanceFeePenaltyTicketState.CHARGE_FAILED,
                HighwayMaintenanceFeePenaltyTicketState.COMPLETED,
                HighwayMaintenanceFeePenaltyTicketState.NO_FEE,
                HighwayMaintenanceFeePenaltyTicketState.QUERY_FAILED,
              ]}
              defaultOptions={{
                fromDate: startOfMonth(now),
                toDate: endOfMonth(now),
              }}
              mode={mode}
            />
          </Tabbar>
        </Layout>
      </Paper>
    </>
  );
}

export default HistoryTickets;
